var Backbone = require('backbone')
var Config = require('config')
var App = require('app')
var BaseModel = require('src/common/base-model')
var BaseCollection = require('src/common/base-collection')

var ScheduleEntity = require('./schedules.js')

var Devices = function () {
  console.warn('Devices.js directly requires the schedules.js entity.')
  var scheduleEntity = new ScheduleEntity()

  var SchedulesCollection = Backbone.Collection.extend({
    model: scheduleEntity.Model,
    url: function () {
      return this.device.url() + '/schedules' // this mean that the AuthorCollection must reference an Author
    }
  })

  // special model which fetches the devices as geo and keeps it inside one model
  // for performance reasons
  var DevicesGeo = BaseModel.extend({
    urlRoot: Config.api.host + '/devices',
    fetch: function (options) {
      options = options || {}
      _.merge(options, {'data': {'$format': 'geojson'}})

      // console.log(options)

      // console.log('rrrr')
      // console.log(arguments.length)
      // if (arguments.length <= 0) arguments[0] = {'data':{}}
      // console.log(arguments)
      // // add the geojson attribute
      // arguments[0].data['$format'] = 'geojson';
      BaseModel.prototype.fetch.apply(this, [options])
    }
  })
  // init
  var Device = BaseModel.extend({
    initialize: function (objects) {
      var self = this
      self.schedules = new SchedulesCollection()
      self.schedules.device = self // setting the author to the collection
    // self.on('sync', function () {
    //   console.log('add')
    // })
    },
    urlRoot: Config.api.host + '/devices',
    idAttribute: '_id',
    defaults: {
    },
    validation: {
    },
    //
    setLocation: function (lat, lng) {
      if (!this.get('geoLocation')) return false
      this.set('geoLocation', [lat, lng])
    },
    resetErrorState: function (callback) {
      Backbone.ajax({
        type: 'POST',
        url: this.url() + '/error-reset',
        data: JSON.stringify({}),
        success: function (val) {
          App.dialog.notice('Error was resetted successfully.')
          if (callback) callback(null)
        },
        error: function (val) {
          App.dialog.alert('Error could not be resetted.')
          if (callback) callback(err)
        }
      })
    },
    saveMany: function (query, data, options) {
    },
    setRegister: function(registerKey, registerValue) {
      let self = this

      Backbone.ajax({
        type: 'POST',
        url: this.url() + '/set-register',
        data: JSON.stringify({register:parseInt(registerKey), value:registerValue}),
        success: function (response) {
          self.set(response)
          App.dialog.notice('The register has been queued to be sent.')
         // if (callback) callback(null)
        },
        error: function (val) {
          App.dialog.alert('Error could not set register.')
         // if (callback) callback(err)
        }
      })

      // var options = {}
      // options['patch'] = true

      // let data = {
      //   name:'cc',
      //   sensors:{
      //     modbus_registers:{
      //       value:{

      //       }
      //     }
      //   }
      // }

      // data.sensors.modbus_registers.value[registerKey] = registerValue      
      // this.save(data, options)


    },
    sendTheCommand: function (commands, options) {
      options = options || {}

      Backbone.ajax({
        type: 'POST',
        url: Config.api.host + '/commands/',
        data: JSON.stringify(commands),
        success: function (val) {
          if (options.success) options.success(val)
        },
        error: function (val) {
          if (options.error) {
            options.error(val)
          } else {
            App.dialog.alert('Something went wrong while controlling the device.')
          }
        }
      })
    },
    sendCommand: function (data, options) {
      options = options || {}
      var command = {}
      command[data.command] = data.value

      var commandData = {
        'devices': [this.get('_id')],
        'commands': command
      }

      this.sendTheCommand(commandData, options)
    }

  })

  var DevicesCollection = BaseCollection.extend({
    url: Config.api.host + '/devices',
    model: Device,
    state: {
      pageSize: 100,
      firstPage: 0
    },
    // sendCommand: function (commands) {
    //   Backbone.ajax({
    //     type: 'POST',
    //     url: Config.api.host + '/commands/',
    //     data: JSON.stringify(commands),
    //     success: function (val) {
    //     },
    //     error: function (val) {
    //       console.log(val)
    //       App.dialog.alert('Something went wrong while controlling the device.')
    //     }
    //   })
    // },
    sendBulkCommand: function (data, options) {
      var self = this

      var defaultOptions = {
        updateCollection: false
      }
      var options = _.extend(defaultOptions, options)

      // get a list of model id's to address in the bulk save
      var bulkIds = self.getBulkIds()

      var command = {}
      command[data.command] = data.value

      var commandData = {
        'devices': bulkIds,
        'commands': command
      }

      Backbone.ajax({
        type: 'POST',
        url: Config.api.host + '/commands/',
        data: JSON.stringify(commandData),
        success: function (val) {
        },
        error: function (val) {
          App.dialog.alert('Something went wrong while controlling the device.')
        }
      })
    }
    // parse: function (data) {
    //   if (!data.data) return data
    //   return data.data
    // }

  })

  // //
  var API = {
    getDeviceGeoEntities: function (options) {
      var options = options || {}

      // // if (options) {
      // //   if (options.query) fetchParams.data = options.query
      // // }
      // options['query'] = {
      //   '$format': 'geojson'
      // }
      var devices = new DevicesGeo()
      devices.fetch(options)
      return devices
    },
    getDeviceEntities: function (options) {
      var options = options || {}
      var fetchParams = {
        reset: true,
        cache: true,
        prefill: true
      }

      if (options) {
        if (options.query) fetchParams.data = options.query
      }
      var devices = new DevicesCollection([], options)
      //  devices.state.pageSize = null

      if (!options.noFetch) {
        devices.fetch(fetchParams)
      }
      return devices
    },
    getDeviceEntity: function (id, options) {
      var options = options || {}
      var device = new Device({_id: id})
      device.fetch(options)
      return device
    },
    newDeviceEntity: function () {
      return new Device()
    },
    newDeviceEntity: function () {
      return new Device()
    }
  }

  App.globalChannel.reply({
    'device:geo:entities': API.getDeviceGeoEntities,
    'device:entities': API.getDeviceEntities,
    'device:entity': API.getDeviceEntity
  })

  App.globalChannel.reply('device:entity:new', function () {
    return API.newDeviceEntity()
  })

//
}

module.exports = Devices



// WEBPACK FOOTER //
// ./js/entities/devices.js